import React from "react";
import { ErrorBoundary } from "@sentry/react";
import setWrappedComponent from "../utils/react/setWrappedComponent";
import ErrorPage from "../components/ErrorMessage";

const errorPage = <ErrorPage errorCode="" />;

export default function withErrorBoundary(WrappedComponent) {
  function WithErrorBoundary(props) {
    return (
      <ErrorBoundary fallback={errorPage}>
        <WrappedComponent {...props} />
      </ErrorBoundary>
    );
  }

  setWrappedComponent(WithErrorBoundary, WrappedComponent);

  return WithErrorBoundary;
}
